function listenerSet() {
  const listeners = new Set<() => void>()
  return {
    on(listener: () => void): () => void {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    emit(): void {
      listeners.forEach((listener) => listener())
    },
  }
}

export const { on: onSessionExpired, emit: emitSessionExpired } = listenerSet()
export const { on: onPermissionDenied, emit: emitPermissionDenied } = listenerSet()
